export default "__VITE_ASSET__DXFi9_ny__"